var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"VOLUME_DOWN","name":"VOLUME_DOWN","data-vcode":"VolumeDown","disabled":"","aria-label":`${_vm.$t('volumeDown')}`}},[_c('img',{attrs:{"src":"/images/icons/volumeDown.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('volumeDown')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }